import TransUnionIcon from "src/assets/TransunionIcon.svg?react";
import {
  getDefaultTransUnionTruVisionCreditReport,
  getDefaultTransUnionTruVisionModelReport,
} from "src/connections/connectionConfigs/transUnion/transUnionResources";
import { TransUnionTemplate } from "src/connections/connectionConfigs/transUnion/transUnionTemplate";
import { ConnectionConfig } from "src/connections/connectionConfigs/types";

export const TRANSUNION_CONFIG: ConnectionConfig<"trans_union"> = {
  icon: TransUnionIcon,
  description: "More precisely balance risk and opportunity",
  template: TransUnionTemplate,
  name: "TransUnion",
  resources: {
    tru_vision_model_report: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/credit-bureaus/transunion#truvision-model-report",
      integrationResource: getDefaultTransUnionTruVisionModelReport,
    },
    tru_vision_credit_report: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/credit-bureaus/transunion#truvision-credit-report",
      integrationResource: getDefaultTransUnionTruVisionCreditReport,
    },
  },
};
